<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-social-handle">
      <i
        v-if="display.iconClass"
        class="grid-field-social-handle__icon"
        :class="display.iconClass"
        role="img"
        :aria-label="iconLabel"
      ></i>
      <!-- Styled as a link but NOT an <a>: an unselected cell must select on
           click like every other cell. The real clickable anchor lives in
           GridViewFieldSocialHandle.vue, matching Baserow's select-then-interact
           model - the same split FunctionalGridViewFieldURL.vue uses. -->
      <span class="grid-field-social-handle__text">
        <SearchHighlightedText :text="display.text" :search-term="searchTerm" />
      </span>
      <i
        v-if="display.unparsed || display.mismatch"
        class="grid-field-social-handle__warning iconoir-warning-triangle"
        role="img"
        :aria-label="$t('gridViewFieldSocialHandle.flagged')"
      ></i>
    </div>
  </div>
</template>

<script>
import {
  getPlatformName,
  getSocialHandleDisplay,
} from '@baserow/modules/database/utils/socialHandle'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldSocialHandle',
  components: { SearchHighlightedText },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    display() {
      return getSocialHandleDisplay(this.value, this.field.platform)
    },
    iconLabel() {
      return this.display.platform
        ? getPlatformName(this.display.platform)
        : this.$t('gridViewFieldSocialHandle.genericPlatform')
    },
  },
}
</script>
